export interface Project {
  id: string;
  title: string;
  category: string;
  description: string;
  longDescription: string;
  techStack: string[];
  image: string;
  videoUrl?: string;
  demoUrl?: string;
  githubUrl?: string;
  metrics: {
    users?: string;
    performance?: string;
    revenue?: string;
  };
  timeline: {
    date: string;
    title: string;
    description: string;
  }[];
  tags: string[];
  featured: boolean;
}

export const projectsData: Project[] = [
  {
    id: 'shubhdhanam-crm',
    title: 'Shubhdhanam – Agent Loan Portal',
    category: 'CRM Systems',
    description: 'A comprehensive CRM-based agent portal developed for managing all types of loan applications',
    longDescription: 'A comprehensive CRM-based agent portal developed for managing all types of loan applications. Features include Lead Management System, Loan Application Tracking, Agent Performance Dashboard, Document Management, Role-Based Access Control, and Real-Time Status Updates.',
    techStack: ['React', 'Node.js', 'MongoDB', 'Express', 'CRM'],
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
    demoUrl: 'https://crm.shubhdhanam.com/login',
    metrics: {
      users: '500+',
      performance: '99.5%',
      revenue: 'Enterprise'
    },
    timeline: [
      { date: 'Q1 2024', title: 'Planning', description: 'Requirements gathering' },
      { date: 'Q2 2024', title: 'Development', description: 'Core features built' },
      { date: 'Q3 2024', title: 'Testing', description: 'Quality assurance' },
      { date: 'Q4 2024', title: 'Launch', description: 'Production deployment' }
    ],
    tags: ['CRM', 'Loan Management', 'Agent Portal', 'Lead Tracking'],
    featured: true
  },
  {
    id: 'shubhdhanam-website',
    title: 'Shubhdhanam – Official Financial Services Website',
    category: 'Web Development',
    description: 'A modern, responsive website developed to showcase complete financial services',
    longDescription: 'A modern, responsive website developed to showcase complete financial services. Highlights include Service Showcase Pages, Loan Information Modules, Lead Capture Forms, SEO Optimization, Mobile-Responsive Design, and High-Speed Performance.',
    techStack: ['React', 'Next.js', 'Tailwind CSS', 'SEO', 'Responsive Design'],
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    demoUrl: 'https://shubhdhanam.com/',
    metrics: {
      users: '10K+',
      performance: '98%',
      revenue: 'High Traffic'
    },
    timeline: [
      { date: 'Q1 2024', title: 'Design', description: 'UI/UX design phase' },
      { date: 'Q2 2024', title: 'Development', description: 'Frontend & backend' },
      { date: 'Q3 2024', title: 'SEO', description: 'Optimization' },
      { date: 'Q4 2024', title: 'Launch', description: 'Live deployment' }
    ],
    tags: ['Website', 'Financial Services', 'SEO', 'Responsive'],
    featured: true
  },
  {
    id: 'mybhk',
    title: 'MyBHK – Real-Time Property Listing Portal',
    category: 'Real Estate',
    description: 'A smart real estate platform for property listing and live searching',
    longDescription: 'A smart real estate platform for property listing and live searching. Key Features include Advanced Property Search Filters, Real-Time Property Listings, User Login & Dashboard, Lead Inquiry System, and Admin Management Panel.',
    techStack: ['React', 'Node.js', 'MongoDB', 'Real-time Search', 'Admin Panel'],
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
    demoUrl: 'https://mybhk.co/',
    metrics: {
      users: '5K+',
      performance: '97%',
      revenue: 'Growing'
    },
    timeline: [
      { date: 'Q2 2024', title: 'Planning', description: 'Feature planning' },
      { date: 'Q3 2024', title: 'Development', description: 'Portal development' },
      { date: 'Q4 2024', title: 'Testing', description: 'User testing' },
      { date: 'Q1 2025', title: 'Launch', description: 'Public launch' }
    ],
    tags: ['Real Estate', 'Property Listing', 'Search', 'Portal'],
    featured: true
  },
  {
    id: 'estatex',
    title: 'Estatex – Broker Property Management Portal',
    category: 'Real Estate',
    description: 'A dedicated property management platform built specifically for brokers',
    longDescription: 'A dedicated property management platform built specifically for brokers. Core Features include Detailed Property Listings, Broker Dashboard, Property Status Management, Lead Tracking System, and Secure Admin Access.',
    techStack: ['React', 'Node.js', 'PostgreSQL', 'Dashboard', 'CRM'],
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
    demoUrl: 'https://theestatex.com/',
    metrics: {
      users: '2K+',
      performance: '98%',
      revenue: 'Active'
    },
    timeline: [
      { date: 'Q2 2024', title: 'Design', description: 'Broker requirements' },
      { date: 'Q3 2024', title: 'Development', description: 'Platform build' },
      { date: 'Q4 2024', title: 'Beta', description: 'Broker testing' },
      { date: 'Q1 2025', title: 'Launch', description: 'Full release' }
    ],
    tags: ['Real Estate', 'Broker Portal', 'Property Management', 'CRM'],
    featured: true
  }
];
